import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import {TranslateContext} from "../../context/TranslateContext";
import {getTipoImpExpDatiByIdApi} from "./services/TipiImpExpDatiServices";
import InserisciTipoImpExpFiglioView from "./InserisciTipoImpExpFiglioView";

export default function InserisciTipoImpExpFiglioController() {
    const {id, idClasse} = useParams()

    const [padre, setPadre] = useState();

    const {translate} = useContext(TranslateContext);

    const formikRef = useRef();
    const history = useHistory();

    async function getOggettoPadre() {
        const response = await getTipoImpExpDatiByIdApi(id);
        setPadre(response.data.data);
    }

    useEffect(() => {
        getOggettoPadre();
    }, [id]);

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    return (
        <InserisciTipoImpExpFiglioView
            formikRef={formikRef}
            history={history}
            id={id}
            idClasse={idClasse}
            padre={padre}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        />
    );
}